import {Component, inject, OnInit} from '@angular/core';
import {EchoChannelService} from "../../sevices/echo-channel.service";
import {BehaviorSubject} from "rxjs";
import {UserNotificationService} from "../../sevices/user-notification.service";

declare  var $:any;
interface ResponseItem {
  label: string;
  type?: string; // "type" du champ d'entrée (select, input, etc.)
  value?: string; // Valeur de la réponse
  check?: boolean; // Indique si la réponse est sélectionnée (pour les cases à cocher, les options sélectionnées, etc.)
}

interface questionItem {
  index?: number;
  question?: string;
  ignore?: boolean,
  multiple?: boolean;
  type?: string; // "type" du champ (select, input, etc.)
  nbr?: number;
  reponse: ResponseItem[]; // Liste des réponses possibles
}
@Component({
  selector: 'lcms-question-notif',
  templateUrl: './question-notif.component.html',
  styleUrls: ['./question-notif.component.scss'],
})
export class QuestionNotifComponent implements OnInit {
  notifService = inject(EchoChannelService)
  userNotif=inject(UserNotificationService)
  data: questionItem[]  = [
    {
      "index": 3,
      "question": "Quels types de vin produisez-vous principalement ?",
      "multiple": true,
      "type": "checkbox",
      "ignore": false,
      "nbr": 3,
      "reponse": [
        { "label": "Vins blancs", "check":false},
        { "label": "Vins rouges", "check":false},
        { "label": "Vins rosés" , "check":false},
        { "label": "Vins effervescents (mousseux)" , "check":false},
        { "label": "Vins doux" , "check":false},
        { "label": "Vins de dessert", "check":false}
      ]
    },
    {
      "index":4,
      "question": "Avez-vous des certifications viticoles ou biologiques ?",
      "multiple" : true,
      "ignore": false,
      "type" : "checkbox",
      "nbr" : 3,
      "reponse" : [{"label": "Certification biologique", "check":false }, {"label": "Certification biodynamique", "check":false } , {"label": "Certification viticole AOC", "check":false }]
    },
    {
      "index":5,
      "question": "Quelles méthodes de vinification utilisez-vous ?",
      "multiple" : true,
      "ignore": false,
      "type" : "select",
      "nbr" : 3,
      "reponse" : [{"label": "Vinification en cuve inox", "check":false }, {"label": "Vinification en fût de chêne", "check":false } , {"label": "Vinification en amphore", "check":false },
      ]
    },{

      "index": 1,
      "question": "Quels sont vos principaux marchés de vente de vin ?",
      "multiple" : true,
      "ignore": false,
      "type" : "radio",
      "nbr" : 1,
      "reponse" : [    { "label": "Marché local / vente directe à la ferme", "value": "local_market" ,"check":false },
        { "label": "Restaurants et bars", "value": "restaurants_bars" ,"check":false },
        { "label": "Cavistes et magasins spécialisés", "value": "wine_shops","check":false  },
      ]
    },
    {
      "question": "Merci d'avoir participer ",
        "reponse" : []
    }
  ]
  // items$ = this.data.asObservable()
  currentActiveIndex = 0; // Keep track of the current active slide index
  dataLength = this.data.length; // Total number of items in your data array

  isLastItem(): boolean {
    return this.currentActiveIndex === this.dataLength - 1;
  }

  // Function to go to the next item or finish
  nextOrFinish(type: string | null =null): void {
    if(type === 'ignore') {
      this.data[this.currentActiveIndex].ignore = true
    }
    if (!this.isLastItem()) {
      this.currentActiveIndex++; // Move to next item
    }
  }
  prevOrFinish(): void {
    if(this.currentActiveIndex!==0) this.currentActiveIndex-- // Move to next item

  }
  checkIfResponsesIgnored(): boolean {
    return this.data.some((question:any) =>
      !question.ignore && question.reponse.every((response:any) => !response.check)
    );
  }


  toggleCheck(item: any, response: any): void {
    // Check how many are currently selected
    const currentlySelected = item.reponse.filter((res : any) => res.check).length;

    if (item.nbr === 1) {
      // If only one selection is allowed
      item.reponse.forEach((res:any) => {
        res.check = false; // Deselect all first
      });
      // $('.carousel').carousel('next')
      response.check = true; // Select the clicked one
    } else {
      // If "multiple" selections are allowed up to item."nbr"
      if (response.check) {
        // If already checked, allow to uncheck
        response.check = !response.check;
      } else {
        // Only allow to check if we have not reached the limit
        if (currentlySelected < item.nbr) {
          response.check = true;

        }
      }
    }
    if(item.reponse.filter((dt:any)=> dt.check === true).length === item.nbr) {

      $('.carousel').carousel('next')
      this.currentActiveIndex++
    }
  }
  toggleCheckbox(reponse: any , item :any) {
    reponse.check = !reponse.check;

    if(item.reponse.filter((dt:any)=> dt.check === true).length === item.nbr) {

      $('.carousel').carousel('next')
      this.currentActiveIndex++
    }
  }
  save(){
    $('#kt_modal_1').modal('hide');
    console.log(this.data)
  }

  ngOnDestroy(): void {
    this.data =[] ;
  }

  ngOnInit(): void {
    // $('#kt_modal_1').modal('show');
  }
  radioNext(item: any): void {
    if(item.reponse.filter((dt:any)=> dt.check === true).length === item.nbr) {

      $('.carousel').carousel('next')
      this.currentActiveIndex++
    }
  }
}
